import {createAction, props} from '@ngrx/store';
import {FeatureStoreNames, SignalStoreNames} from '@shared-types';

import {StoreGlobalActionType} from './global-action.type';

export type IClearStoreGlobalAction = {
	// If provided, clear only the stores in the array
	storesToClear?: (FeatureStoreNames | SignalStoreNames)[];
	// If true, clear all feature stores
	clearFeatureStores?: boolean;
	//	If true, clear all signal stores
	clearSignalStores?: boolean;
};

export const clearStoreGlobalAction = createAction<StoreGlobalActionType.CLEAR_STORE, IClearStoreGlobalAction>(StoreGlobalActionType.CLEAR_STORE, props<IClearStoreGlobalAction>());
